module.exports = __webpack_public_path__ + "assets/e6b28280ff1e4c14e0079903276edd8d.png";